export const useUtcTime = () => {
    const now = new Date();
    const isoString = now.toISOString();
    return isoString;
}